import React from 'react';
import { Outlet, Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  return (
    <>
      <nav className='navcontainer' aria-label='Primary navigation'> 
        <Link className='logo' to='/' aria-label="ET's Space home">
          ET's Space
        </Link>
        <div className='navLinks'>
          <ul className='list'>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/search">Search</Link>
            </li>
            <li>
              <a href="https://arghyadev.netlify.app/" target="_blank" rel="noreferrer">About</a>
            </li>
          </ul>
        </div>
      </nav>

      <Outlet />
    </>
  )
}

export default Navbar



